import { defineMessages, IntlShape } from "react-intl";

import CommonFieldName from "@app/util/fieldModel/CommonFieldName";
import { getDisplayName } from "@app/util/ui";

enum SortField {
  NAME = CommonFieldName.NAME,
  CREATED_AT = CommonFieldName.CREATED_AT,
  GEOPOINT = CommonFieldName.GEOPOINT,
  LAST_ACTIVITY_DATE = CommonFieldName.LAST_ACTIVITY_DATE,
  NEXT_ACTIVITY = CommonFieldName.NEXT_ACTIVITY,
  UPDATED_AT = CommonFieldName.UPDATED_AT,
}

const messages = defineMessages<SortField>({
  [SortField.CREATED_AT]: {
    id: "recordList.customization.sort.field.createdAt",
    defaultMessage: "Date Created",
    description: "Date Created field label",
  },
  [SortField.GEOPOINT]: {
    id: "recordList.customization.sort.field.geoPoint",
    defaultMessage: "Location",
    description: "Location field label",
  },
  [SortField.LAST_ACTIVITY_DATE]: {
    id: "recordList.customization.sort.field.lastCompletedActivity",
    defaultMessage: "Date of last done activity",
    description: "Date of last done activity field label",
  },
  [SortField.NAME]: {
    id: "recordList.customization.sort.field.name",
    defaultMessage: "Alphabetical",
    description: "Alphabetical field label",
  },
  [SortField.NEXT_ACTIVITY]: {
    id: "recordList.customization.sort.field.upcomingActivity",
    defaultMessage: "Date of Next Activity",
    description: "Date of Next Activity field label",
  },
  [SortField.UPDATED_AT]: {
    id: "recordList.customization.sort.field.updatedAt",
    defaultMessage: "Date Modified",
    description: "Date Modified field label",
  },
});

export const getSortFieldDisplayName = (intl: IntlShape, sortField: SortField) =>
  getDisplayName(intl, messages, sortField, "SortField");

export default SortField;
